import { Box } from '@chakra-ui/react'
import { ScreenContext, useCollection } from '@hb/react'
import { FieldMap, FieldTypes, RevenueCodeEntry, revenueCodesCollection } from '@hb/shared'
import { useContext } from 'react'
import { EditCollection } from '../../../EditCollection'
import { EditedProps } from '../../../EditHeader'
import { FormElement } from '../../../forms/Input'

const revenueCodeFields: FieldMap = {
  name: 'Revenue Code',
  children: {
    code: {
      type: FieldTypes.TEXT,
      placeholder: 'UB-04 revenue code (e.g. 0270)',
    },
    description: {
      type: FieldTypes.TEXT,
      placeholder: 'Description (e.g. Medical/Surgical Supplies)',
    },
    defaultHcpcsCode: {
      type: FieldTypes.TEXT,
      placeholder: 'Default HCPCS code (optional, e.g. A4217)',
      optional: true,
    },
  },
}

const RevenueCodeBody = ({ expanded }: EditedProps<RevenueCodeEntry>) =>
  expanded ? (
    <Box w="100%" p={4}>
      <FormElement active name="" field={revenueCodeFields} />
    </Box>
  ) : null

export const RevenueCodesAdminView = () => {
  const { contentWidth } = useContext(ScreenContext)
  const data = useCollection(revenueCodesCollection)
  if (!data) return null
  return (
    <EditCollection
      collection={revenueCodesCollection}
      data={data}
      width={contentWidth}
      ItemComponent={RevenueCodeBody}
      name="Revenue Code Registry"
      itemPlaceholder="Revenue code"
      itemName="Revenue Code"
    />
  )
}
